import React from 'react';
import { useTranslation } from 'react-i18next';
import { Domain } from '../../types/data';

interface StatusMessageProps {
  targetCompany: string | null;
  activeDomain: Domain | string | null;
}

const StatusMessage: React.FC<StatusMessageProps> = ({ targetCompany, activeDomain }) => {
  const { t } = useTranslation();

  if (!targetCompany) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="bg-white shadow-lg rounded-lg p-8 text-center">
          <h2 className="text-md">{t('common.please_select_company')}</h2>
        </div>
      </div>
    );
  }

  if (!activeDomain) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="bg-white shadow-lg rounded-lg p-8 text-center">
          <h2 className="text-md">{t('common.selected_company_has_no_domains')}</h2>
        </div>
      </div>
    );
  }

  return null; // Render nothing if both props are valid
};

export default StatusMessage;
